import { render, staticRenderFns } from "./AcknowledageTab.vue?vue&type=template&id=10c90cd1&scoped=true"
import script from "./AcknowledageTab.vue?vue&type=script&lang=js"
export * from "./AcknowledageTab.vue?vue&type=script&lang=js"
import style0 from "./AcknowledageTab.vue?vue&type=style&index=0&id=10c90cd1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c90cd1",
  null
  
)

export default component.exports